$('.icon-carousel-item').owlCarousel({
    loop: true,
    margin: 10,
    responsiveClass: true,
    autoplayTimeout: 2500,
    autoplay: true,
    nav: false,
    dots: false,
    rtl: true,
    responsive: {
        0: {
            items: 3,
            nav: true
        },

        600: {
            items: 5,
            nav: false
        },
        1000: {
            items: 8,
            nav: true,
            loop: true
        }
    }
})